import React from 'react';
import GeneralTableColumn from "../../../Components/GeneralTableColumn";
import moment from "moment";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-regular-svg-icons";
import {faMobile, faMobileAlt} from "@fortawesome/free-solid-svg-icons";
import jwt from "jsonwebtoken";
import LandingCommunityLogsUpdate from "./LandingCommunityLogsUpdate";

const jwtKey = process.env.REACT_APP_JWT_KEY;

/*
    @param {object} row - this is the dataset
    @param {array} data - more data
    @param {function} setLoading
    @return {JSX.Element}
 */

export default function LandingCommunityLogsMyTableRow({ row,data, setLoading ,setRefreshTrigger}) {

    const [openChange,setOpenChange] = React.useState(false);
    const [openChangeRedeemed,setOpenChangeRedeemed] = React.useState(false);

    return (
        <>
            <GeneralTableColumn>
                <div>{row.sn}</div>
                <div>
                    <a href={""} onClick={(e) => printVoucher(e,row,data)}>View voucher</a>
                </div>
            </GeneralTableColumn>
            <GeneralTableColumn>
                <div>{moment(row.created_at).format('DD/MM/YYYY')}</div>
                <a href={""} onClick={(e) => {
                    e.preventDefault();
                    setOpenChange(true)
                }}>Change details</a>
                <LandingCommunityLogsUpdate open={openChange} setOpen={setOpenChange} row={row} mode={"issued"} setLoading={setLoading}  setRefreshTrigger={setRefreshTrigger} />
            </GeneralTableColumn>
            <GeneralTableColumn>
                {
                    row.is_redeemed > 0 &&
                    <>
                        <div>{moment(row.redeemed_at).format('DD/MM/YYYY')}</div>
                        <a href={""} onClick={(e) => {
                            e.preventDefault();
                            setOpenChangeRedeemed(true)
                        }}>Change details</a>
                        <LandingCommunityLogsUpdate open={openChangeRedeemed} setOpen={setOpenChangeRedeemed} row={row} mode={"redeemed"} setLoading={setLoading} setRefreshTrigger={setRefreshTrigger}  />
                    </>
                }
            </GeneralTableColumn>
            <GeneralTableColumn>
                <div><strong>{row.vet_name}</strong></div>
            </GeneralTableColumn>
            <GeneralTableColumn>
                <strong>{row.first} {row.last}</strong><br/>
                <FontAwesomeIcon icon={faEnvelope} style={{marginRight:10}} />{row.email}<br/>
                <FontAwesomeIcon icon={faMobileAlt}  style={{marginRight:10}}/>{row.phone}<br />
                {row.suburb} {row.city} {row.postcode}
            </GeneralTableColumn>
            <GeneralTableColumn>
                <strong>{row.a_type} ({row.a_gender})</strong><br/>
                <>Name: {row.a_name} </><br/>
                {row.is_redeemed === 1 && <>Surgery: {row.a_type_surgery}<br/></>}
                {row.is_redeemed > 0 && <><span>{moment(row.a_date_surgery).format('DD/MM/YYYY')}</span><br/></>}
                {row.is_redeemed === 1 && <>Microchip Number: {row.a_microchip_number}<br/></>}
            </GeneralTableColumn>
         
        </>
    )
}

function printVoucher(e,voucher, data) {

    e.preventDefault();

    let dataAnimals = data.filter((x) => x.order_id === voucher.order_id);
    let arr = [];
    let expiry = null;
    for (let x in dataAnimals) {
        const r = dataAnimals[x];
        arr.push({
            name: r.a_name,
            voucher: r.sn,
            expiry_date: r.expiry_date,
            expiry: r.expiry_date
        });
        if (!expiry || expiry < r.expiry_date) expiry = r.expiry_date;
    }


    const urlJwt = {
        name: voucher.business_name,
        order_id: voucher.order_id,
        email: voucher.email,
        user: voucher.first + " " + voucher.last,
        vet_id: voucher.vet_id,
        expiry: moment(expiry).format('YYYY-MM-DD'),
    };

    let url = 'print/?com=1&cid=' + jwt.sign({...urlJwt, vouchers: arr}, jwtKey) + '&exp=' + moment(expiry).format('YYYY-MM-DD');
    //console.log(url);
    const newWindow = window.open(url, '_blank',
        'noopener,noreferrer'
    );

    if (newWindow) newWindow.opener = null
}
